import React, { useState } from "react";
import logo from "../assets/sec_logo.svg";
import "../App.css";
import { statesData } from "../components/statesData";
import { Link } from "react-router-dom";
import {
 FaFacebookF,
 FaInstagram,
 FaYoutube,
 FaLinkedinIn
} from "react-icons/fa";

const Footer = () => {

  // READ MORE STATE
  const [showAllStates, setShowAllStates] = useState(false);

  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Left - Logo & Text */}
        <div className="footer-left">

          <Link to="/">
            <img
              src={logo}
              alt="Logo"
              className="navbar-logo"
              loading="lazy"
                rel="preload"
            />
          </Link>

          <p>
            Premium kitchen and wardrobe hardware solutions
            crafted for durability, style, and high performance.
            Designed to enhance modern living spaces, our
            products combine strength, elegance, and
            functionality to deliver long-lasting reliability
            and a refined aesthetic for every home and workspace.
          </p>

        </div>

        {/* Center - Links */}
        <div className="footer-center">

          <div className="footer-column">

            <h4>Home</h4>

            <a href="/">Home</a>
            <a href="/cabinet-hinges">Product</a>
            <a href="/about">About Us</a>
            <a href="/contact">Contact</a>
            <a href="/kitchen-baskets">Kitchens Basket</a>
            <a href="/cabinethingesinstallation">Cabinet Hinges Installation</a>
            {/* <a href="/catalogue.pdf">Product Catalogue</a>
     <a href="/price-list.pdf" target="_blank" rel="noopener noreferrer">
  Price List
</a> */}
          </div>

          {/* ALL STATES */}
          <div className="footer-column">

            <h4>All States</h4>

            {(showAllStates
              ? statesData
              : statesData.slice(0, 4)
            ).map((state, index) => (
              <Link
                key={index}
                to={`/hardware-in/${state.name
                  .toLowerCase()
                  .replace(/\s+/g, "-")}`}
              >
                {state.name}
              </Link>
            ))}

            {/* READ MORE BUTTON */}
            {statesData.length > 4 && (
              <span
                className="read-more-btn"
                onClick={() =>
                  setShowAllStates(!showAllStates)
                }
              >
                {showAllStates
                  ? "Read Less"
                  : "Read More"}
              </span>
            )}

          </div>

          {/* LEGAL */}
          <div className="footer-column">

            <h4>Legal</h4>

            <a href="/privacy-policy">
              Privacy Policy
            </a>

            <a href="/terms-conditions">
              Terms & Conditions
            </a>

          
          </div>

        </div>

        {/* Right - Social + Call */}
        <div className="footer-right">

          <div className="social-icons">

            <a
              href="https://www.linkedin.com/in/slimline-hardware-20a9813ba/"
              target="_blank"
              rel="noreferrer"
              className="social-box"
               aria-label="Visit our Linkedin"
        
            >
              <FaLinkedinIn />
            </a>

            <a
              href="https://www.facebook.com/profile.php?id=61586161063892"
              target="_blank"
              rel="noreferrer"
              className="social-box"
               aria-label="Visit our Facebook page"
            >
               <FaFacebookF />
            </a>


            <a
              href="https://www.instagram.com/slimlinesales/"
              target="_blank"
              rel="noreferrer"
              className="social-box"
                     aria-label="Visit our Instagram page"
            >
                <FaInstagram />
            </a>

            <a
              href="https://www.youtube.com/@SlimlineSales"
              target="_blank"
              rel="noreferrer"
              className="social-box"
                aria-label="Visit our YouTube channel"
            >
                 <FaYoutube />
            </a>

          </div>

          <a
            href="tel:9650100908"
            className="contact-btn"
          >
            Call Now
          </a>

        </div>

      </div>

      {/* BOTTOM */}
      <div className="footer-bottom">
        © 2026 Slimline. All Rights Reserved.
      </div>

    </footer>
  );
};

export default Footer;